module.exports = __webpack_public_path__ + "static/media/Teil_3_Neu_Backward.743288cd.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/Teil_3_Neu_Backward.ogv
// module id = 122
// module chunks = 0